import { render, staticRenderFns } from "./special-extract.vue?vue&type=template&id=09d1218f"
import script from "./special-extract.vue?vue&type=script&lang=js"
export * from "./special-extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports